// extracted by mini-css-extract-plugin
module.exports = {"popup_pos":"formModal_popup_pos__KOGTy","main_popup":"formModal_main_popup___SMXw"};